function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "DropDown",
  className: "all",
  d: "M22.118 2.119l-10 11-10-11",
  fill: "none",
  stroke: "#002d56",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.238,
    height: 15.349,
    viewBox: "0 0 24.238 15.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNC4yMzgiIGhlaWdodD0iMTUuMzQ5IiB2aWV3Qm94PSIwIDAgMjQuMjM4IDE1LjM0OSI+CiAgPHBhdGggaWQ9IkRyb3BEb3duIiBjbGFzcz0iYWxsIiBkPSJNMjc2LjcsMTUzLjg3bDEwLTExLDEwLDExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOTguODE4IDE1NS45ODkpIHJvdGF0ZSgxODApIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };